import { render } from "./CurrentUserInfo.vue?vue&type=template&id=1e8ef9c0"
import script from "./CurrentUserInfo.vue?vue&type=script&lang=js"
export * from "./CurrentUserInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__